// extracted by mini-css-extract-plugin
export var active = "_ju-2";
export var recordingDot = "_ju-1";
export var recordingIndicator = "_ju-0";